<template>
  <div class="testimonial-section">
    <div class="testimonial-nav">
      <span class="bar"></span>
      <h2>{{ $t("uquvchilar_fikri") }}</h2>
    </div>

    <swiper
      :modules="[Navigation, Autoplay]"
      :slides-per-view="3.5"
      :space-between="35"
      :loop="true"
      :breakpoints="{
        1024: { slidesPerView: 3 },
        768: { slidesPerView: 2 },
        480: { slidesPerView: 1.5 },
        380: { slidesPerView: 1 },
      }"
      navigation
      class="testimonial-carousel"
    >
      <swiper-slide
        v-for="(video, index) in videos"
        :key="index"
        class="testimonial-card"
      >
        <video
          controls
          width="100%"
          preload="metadata"
          class="testimonial-video"
          ref="videos"
          @play="pauseOtherVideos(index)"
        >
          <source :src="video" type="video/mp4" />
          Sizning brauzeringiz video tag'ni qo‘llab-quvvatlamaydi.
        </video>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Autoplay } from "swiper/modules";
import playvideo from '@/components/Template/Icons.vue'
import video1 from '@/assets/Videos/video1.mp4'
// import video2 from '@/assets/Videos/video2.mp4'
import video3 from '@/assets/Videos/video3.mp4'
import video4 from '@/assets/Videos/video4.mp4'
import video5 from '@/assets/Videos/video5.mp4'
import video6 from '@/assets/Videos/video6.mp4'
import video7 from '@/assets/Videos/video7.mp4'
import video8 from '@/assets/Videos/video8.mp4'
import Yulduz from '@/assets/Videos/yulduz.mp4'


export default {
  components: {
    Swiper,
    SwiperSlide,
    // playvideo
  },
  setup() {
    return {
      Navigation,
      Autoplay,
    };
  },
  data() {
    return {
      videos: [
        // video8,
        // Yulduz,
        video4,
        // video2,
        video3,
        video5,
        video6,
        video7,
        video1,


      ],
    };
  },
  methods: {
    pauseOtherVideos(currentIndex) {
      const allVideos = this.$refs.videos;
      if (Array.isArray(allVideos)) {
        allVideos.forEach((video, index) => {
          if (index !== currentIndex && !video.paused) {
            video.pause();
          }
        });
      }
    }
  }


};
</script>

<style>
.testimonial-nav {
  display: flex;
  align-items: center;
  gap: 10px;
}
.testimonial-nav .bar {
  width: 4px;
  height: 43px;
  background: yellow;
}
.testimonial-nav h2 {
  font-size: 32px;
  font-weight: 500;
}
.testimonial-section {
  position: relative;
  text-align: start;
  background: #000;
  color: white;
  margin-top: 35px;
  padding: 0px 0;
}

.testimonial-carousel {
  width: 100%;
  position: relative;
  margin-top: 40px;
  height: 640px;
  margin-bottom: 30px;
}

.testimonial-card {
  min-width: 339px;
  height: 600px;
}
.testimonial-video {
  height: 100%;
  border-radius: 10px;
  aspect-ratio: 26 / 9;
}
.testimonial-video video {
  width: 100%;
  height: 100%;
}

/* .testimonial-card .iconplayer{
  position: absolute;
  top: 45%;
  left: 45%;
} */

/* .user-image-play{
  cursor: pointer;
} */
/* Footer */
.testimonial-footer {
  width: 60%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  position: absolute;
  left: 0;
  bottom: 5%;
}

.testimonial-footer-text h3 {
  font-size: 30px;
  font-family: Nohemi;
  font-weight: 500;
}

.testimonial-footer-text p {
  font-size: 10px;
  font-family: Manrope;
  font-weight: 400;
}
.testimonial-footer-text {
  margin-left: -10%;
}

.user-image {
  width: 67px;
  height: 67px;
  border-radius: 50%;
}

.testimonial-carousel::after {
  content: "";
  position: absolute;
  z-index: 1;
  top: 0;
  right: 0;
  width: 100px;
  height: 100%;
  background: linear-gradient(to left, rgba(0, 0, 0, 1), transparent);
  pointer-events: none;
}

.swiper-button-prev {
  box-sizing: content-box;
  position: absolute;
  z-index: 2;
  top: 97%;
  left: 94.5%;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  padding: 5px;
  background-color: #1f1c1c;

  color: #fff;
}

.swiper-button-next {
  box-sizing: content-box;
  /* z-index: 10; */
  position: absolute;
  top: 97%;
  right: 1px;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  padding: 5px;
  background-color: #fff;
  transition: all 0.3s ease;

  color: #000;
}
.swiper-button-next::after,
.swiper-button-prev::after {
  font-size: 14px;
  font-weight: 900;
}
.swiper-button-prev:hover,
.swiper-button-prev:active {
  background-color: #ffffff;
  color: #000;
}

.swiper-button-next:hover,
.swiper-button-next:active {
  background-color: #fff;
  color: #000;
}

@media (max-width: 1440px) {
  .swiper-button-prev {
    left: 85%;
    width: 30px;
    height: 30px;
    background-color: #000;
    color: #fff;
    border-radius: 50%;
    padding: 5px;
    transform: translateY(-10px);
  }
  .swiper-button-next {
    right: 0 !important;
    width: 30px;
    height: 30px;
    background-color: #fff;
    color: #000;
    border-radius: 50%;
    padding: 5px;
    transform: translateY(-10px);
  }
}

@media (max-width: 768px) {
  .testimonial-carousel {
    height: 460px;
  }
  .testimonial-card {
    min-width: 300px;
    height: 400px;
  }
  .testimonial-card2 {
    max-width: 300px;
  }
  .swiper-button-prev {
    width: 30px;
    left: 82%;
    bottom: -30px;
    height: 30px;
    background-color: #000;
    color: #fff;
    border-radius: 50%;
    padding: 5px;
  }
  .swiper-button-next {
    right: 0 !important;
    width: 30px;
    height: 30px;
    background-color: #fff;
    color: #000;
    border-radius: 50%;
    padding: 5px;
  }
}

@media (max-width: 480px) {
  .testimonial-card {
    min-width: 300px;
    height: 400px;
  }

  .swiper-button-prev {
    width: 30px;
    left: 78%;
    margin-left: -30px;
    bottom: -30px;
    height: 30px;
    background-color: #000;
    color: #fff;
    border-radius: 50%;
    padding: 5px;
  }
  .swiper-button-next {
    right: 0 !important;
    width: 30px;
    height: 30px;
    background-color: #fff;
    color: #000;
    border-radius: 50%;
    padding: 5px;
  }
}
</style>
